import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface OrganisationFilterState {
  selectedOrganisationIds: number[]

  setSelectedOrganisationIds: (ids: number[]) => void
  clearFilter: () => void
}

export const useOrganisationFilterStore = create<OrganisationFilterState>()(
  persist(
    (set) => ({
      selectedOrganisationIds: [],

      setSelectedOrganisationIds: (ids) => set({ selectedOrganisationIds: ids }),
      clearFilter: () => set({ selectedOrganisationIds: [] }),
    }),
    {
      name: 'junea-organisation-filter',
      partialize: (state) => ({
        selectedOrganisationIds: state.selectedOrganisationIds,
      }),
    },
  ),
)
